// src/config.js

const config = {
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
  websocketUrl: process.env.REACT_APP_WEBSOCKET_URL,
  authorizationApiEndpoint:
    process.env.REACT_APP_AUTHORIZATION_API_ENDPOINT ||
    process.env.REACT_APP_API_ENDPOINT,
  servicesApiEndpoint:
    process.env.REACT_APP_SERVICES_API_ENDPOINT ||
    process.env.REACT_APP_API_ENDPOINT,
  devStreamWebSocketUrl:
    process.env.REACT_APP_DEV_STREAM_WS_URL ||
    "wss://dev-streams.romancontrols.com",
  apiKey: process.env.REACT_APP_API_KEY,
  enableConsoleLogging: process.env.REACT_APP_ENABLE_CONSOLE_LOGGING === "true",
  patronLimit: parseInt(process.env.REACT_APP_PATRON_LIMIT || "10", 10),
  yonomiGraphQLEndpoint:
    process.env.REACT_APP_YONOMI_GRAPHQL_ENDPOINT ||
    "https://services.yonomi.cloud/graphql",
  // SECURITY: Device settings password must be set via environment variable
  // No hardcoded fallback - if not set, the feature will be disabled
  deviceSettingsPassword:
    process.env.REACT_APP_DEVICE_SETTINGS_PASSWORD || null,
};

// This simple validation helps catch configuration errors early.
if (!config.apiEndpoint || !config.websocketUrl || !config.apiKey) {
  // eslint-disable-next-line no-console -- Critical config error must be logged
  console.error(
    "CRITICAL ERROR: Missing one or more required environment variables. Please ensure REACT_APP_API_ENDPOINT, REACT_APP_WEBSOCKET_URL, and REACT_APP_API_KEY are defined in your .env files."
  );
}

// Error if device settings password is not configured
if (!config.deviceSettingsPassword) {
  // eslint-disable-next-line no-console -- Critical config error must be logged
  console.error(
    "ERROR: REACT_APP_DEVICE_SETTINGS_PASSWORD is not set. Device settings download feature will be unavailable."
  );
}

export default config;
